interface TickIconProps {
  width?: number;
  height?: number;
}
const TickIcon: React.FC<TickIconProps> = ({ width = 11, height = 13 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 14"
      fill="none"
    >
      <path
        d="M0 11.6667H11.6667V13.3333H0V11.6667ZM3.83333 9.41667L0 5.58333L1.66667 4L3.83333 6.16667L10 0L11.6667 1.66667L3.83333 9.41667Z"
        fill="#323232"
      />
    </svg>
  );
};

export default TickIcon;
